import React, {useState} from "react";
import Link from "next/link";

const Includes: React.FC = ({ children }) => {
  const [themeValue, setthemeValue] = useState<number>(1)

  const toggleTheme = (x) => {
    if(x === 'up'){
      themeValue < 17 ? setthemeValue(themeValue + 1) : setthemeValue(1)
    } else {
      themeValue > 1 ? setthemeValue(themeValue - 1) : setthemeValue(17)
    }
  }

  return(
    <>
<section id="venue-hero">
      <div className="cover-shape"></div>
      <div className="content-container maxw1350">
        <h1>See What’s Included Below</h1>
        <p>And add some extra fun and excitement to your event!</p>
        <Link href="/tacboard-pricing">
            <a className="get-tac-now">Get TacBoard Now</a>
        </Link>
      </div>
      <div className="bottom-wave"></div>
    </section>
<section className="includes" id="phone">
      <h2 className="center">
        <span className="line"></span>Unique Phone Number<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
          <picture>
            <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" />

            <img src="img/text01dx1.jpg" alt="TacBoard Gallery on all devices" />
          </picture>
        </div>
        <div className="half">
          <p>
            Sign up anytime within a year of your event and receive your unique phone number immediately! No
            need for anyone to download an app - TacBoard is simply text
            messaging.
          </p>
          <p>
            Start using TacBoard today for pre-event festivities such as party
            planning, bachelor / bachelorette parties or wedding shower!
          </p>
          <p>
            Your unique phone number will remain active until 30 days after your
            event's date, but you'll still be able to view, share, and download
            your photos.
          </p>
        </div>
      </div>
    </section>
    <section className="includes bg-cream" id="live">
      <h2 className="center">
        <span className="line"></span>Live Photo Stream<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
          <video disableRemotePlayback className="thumb-vid" muted loop autoPlay preload="auto">
            <source src="img/av-live-screen.webm" type="video/webm" />
            <source src="img/av-live-screen.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="half">
          <p>
            Easily connect a laptop to a TV or projector to stream your gallery
            live. Your event’s unique phone number appears at the top of the
            screen for quick and easy reference by your guests.
          </p>
          <p>
            If you have a large event you can easily set your Live Photo Stream up on multiple screens and get more of your guest engaging in the fun.
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>
<section className="includes" id="gallery">
      <h2 className="center">
        <span className="line"></span>Online Gallery<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
          <picture>
          <><source type="image/webp" srcSet={`
                img/gallery-theme-${themeValue}.webp,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(min-width: 801px)" />
            <source type="image/webp" srcSet={`
                img/gallery-theme-${themeValue}.webp,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(max-width: 800px)" />

            <source type="image/jpg" srcSet={`
                img/gallery-theme-${themeValue}.jpg,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(min-width: 801px)" />
            <source type="image/jpg" srcSet={`
                img/gallery-theme-${themeValue}.jpg,
                img/gallery-theme-${themeValue}.webp 2x
              `} media="(max-width: 800px)" />

            <img src={`img/gallery-theme-${themeValue}.png`} alt="alt description" /></>
          </picture>
          <div className="view-themes-container">
            <div className="view-themes-btn" onClick={() => toggleTheme('down')}> {`<`} </div>
            <div className="view-theme-text">View Themes</div>
            <div className="view-themes-btn"onClick={() => toggleTheme('up')}> {`>`} </div>
            </div>
        </div>
        <div className="half">
          <p>
            Your private, online gallery includes unlimited photos and free
            photo downloads. You can easily share individual photos or your
            entire gallery through email and social media.
          </p>
          <p>
            Share your Gallery or Live Photo Stream link with those who can't make it to your event and they can tune in and feel included in the festivities from anywhere in the world. 
          </p>
          <h3>Upload Portal</h3>
          <p>
            It's simple to add photos taken by friends and family with their
            fancy digital cameras to your gallery.
          </p>
          <h3>Gallery Themes</h3>
          <p>
            Modern or vintage? Luxurious or rustic? Find your style by choosing
            from one of our 17 gallery themes!
          </p>
        </div>
      </div>
    </section>
<section className="includes bg-cream" id="content-filter">
      <h2 className="center">
        <span className="line"></span>Content Filter<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
          <picture>
            <source type="image/webp" srcSet="
                img/content-screen-animation-short-310.webp,
                img/content-screen-animation-short-455.webp 1.5x
              " />

            <source type="image/gif" srcSet="
                img/content-screen-animation-short-310.gif,
                img/content-screen-animation-short-455.gif 1.5x
              " />

            <img src="img/content-screen-animation-short-310.gif" alt="TacBoard Content Filter" />
          </picture>
        </div>
        <div className="half">
          <p>
            Your built-in Content Filter will flag inappropriate text and images
            before they enter your gallery or Live Photo Stream. Flagged items
            will enter a queue where you can delete or approve them as well as
            block the sender.
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>

<section className="includes" id="sign-shop bg-cream">
      <h2 className="center">
        <span className="line"></span>Free Sign Shop<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
          <picture>
            <source type="image/webp" srcSet="img/sign-shop-sign-selfie-station.webp
                        " />
            <source type="image/jpg" srcSet="img/sign-shop-sign-selfie-station.jpg
                    " />

            <img src="img/sign-shop-sign-selfie-station.jpg" alt="TacBoard Sign Shop" />
          </picture>
        </div>
        <div className="half">
          <p>
            Placing creative signage around your venue is a great way to share
            your gallery's phone number and ensure your guests text all their
            candid photos to your TacBoard phone number. Check out our large
            variety of free signs to download and print in our free sign shop.
          </p>
        </div>
      </div>
    </section>
    </>
)}

export default Includes;
